import axios from 'axios';
import constants from '../constants/appConstants';

export async function fetchUpcomingDisputesCount() {
  const { data } = await axios.get(constants.API.upcomingDisputesVehicles);
  return data?.vehicles?.length || 0;
}
